export default __webpack_public_path__ + "static/media/yellow.9cb1192b.ogg";